// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.trusts {
  max-width: 920px;
}

.tr-lede {
  margin: 2px 0 14px;
  opacity: 0.78;
  line-height: 1.5;
  max-width: 760px;
}

.tr-pause-all {
  font-size: 13px;
}

.tr-agent {
  margin: 0 0 18px;
}

.tr-agent-head {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 6px;
}
.tr-agent-head mat-icon {
  opacity: 0.7;
}
.tr-agent-head .tr-agent-name {
  font-size: 15px;
  font-weight: 600;
}

.tr-none {
  opacity: 0.6;
  padding: 4px 2px 6px 32px;
}

.tr-order {
  margin-left: 32px;
  padding-bottom: 4px;
}

.tr-order.tr-paused {
  opacity: 0.7;
}

.tr-sentence {
  font-size: 14px;
  line-height: 1.5;
}

.tr-chip-paused {
  margin-left: 8px;
  padding: 1px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 500;
  background: rgba(244, 172, 57, 0.18);
  color: #f4ac39;
}

.tr-about {
  margin: 4px 0 2px;
  opacity: 0.85;
}

.tr-meta {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  opacity: 0.9;
}
.tr-meta > span:first-child {
  opacity: 0.65;
}

.tr-editor {
  margin-left: 32px;
  padding-bottom: 12px;
  border-color: rgba(97, 175, 239, 0.55);
}

.tr-field {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 12px 0 0;
  flex-wrap: wrap;
}
.tr-field label {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  opacity: 0.7;
}

.tr-field-col {
  flex-direction: column;
  align-items: stretch;
  gap: 6px;
}

.tr-field-head {
  display: flex;
  align-items: center;
  gap: 10px;
}

.tr-wide {
  width: 100%;
}

.tr-person {
  width: 220px;
}

.tr-template {
  width: 170px;
}

.tr-count {
  font-size: 12px;
  opacity: 0.6;
}

.tr-all {
  min-width: 0;
  padding: 0 8px;
  height: 26px;
  font-size: 12px;
}

.tr-channels {
  max-height: 232px;
  overflow-y: auto;
  border: 1px solid rgba(128, 128, 128, 0.28);
  border-radius: 6px;
}

.tr-channel {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 10px 0 2px;
  min-height: 34px;
  border-bottom: 1px solid rgba(128, 128, 128, 0.16);
  font-size: 13px;
}
.tr-channel:last-child {
  border-bottom: 0;
}
.tr-channel:hover {
  background: rgba(128, 128, 128, 0.08);
}
.tr-channel mat-checkbox {
  flex: none;
}
.tr-channel .tr-channel-note {
  font-size: 12px;
  opacity: 0.6;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.tr-channel .tr-channel-note mat-icon {
  font-size: 13px;
  width: 13px;
  height: 13px;
  vertical-align: -2px;
}
.tr-channel .tr-channel-when {
  font-size: 12px;
  opacity: 0.6;
  white-space: nowrap;
}

.tr-kept {
  margin: 2px 0;
  font-size: 12px;
  opacity: 0.7;
}
.tr-kept mat-icon {
  font-size: 13px;
  width: 13px;
  height: 13px;
  vertical-align: -2px;
}

.tr-never {
  margin: 26px 0 18px;
}

.tr-never-card {
  margin-left: 32px;
  padding-bottom: 10px;
}

.tr-never-lede {
  margin: 2px 0 8px;
  opacity: 0.8;
  line-height: 1.5;
}

.tr-never-floor {
  margin: 10px 0 0;
  line-height: 1.5;
  opacity: 0.75;
}
.tr-never-floor summary {
  cursor: pointer;
}
.tr-never-floor mat-icon {
  font-size: 14px;
  width: 14px;
  height: 14px;
  vertical-align: -2px;
}
.tr-never-floor pre {
  margin: 6px 0 0 20px;
  font-size: 12px;
  line-height: 1.5;
}

.tr-chip-default {
  padding: 1px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 500;
  background: rgba(128, 128, 128, 0.18);
  opacity: 0.8;
}

.tr-editor-foot {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
}
.tr-editor-foot mat-icon {
  font-size: 14px;
  width: 14px;
  height: 14px;
  vertical-align: -2px;
}

.tr-activity {
  display: flex;
  flex-direction: column;
}

.tr-activity-row {
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;
  padding: 9px 10px;
  border: 0;
  border-bottom: 1px solid rgba(128, 128, 128, 0.22);
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
}
.tr-activity-row:hover {
  background: rgba(128, 128, 128, 0.1);
}
.tr-activity-row .tr-activity-who {
  flex: 1;
  min-width: 0;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.tr-activity-row .tr-activity-who mat-icon {
  font-size: 15px;
  width: 15px;
  height: 15px;
  opacity: 0.6;
}
.tr-activity-row .tr-activity-turns, .tr-activity-row .tr-activity-when {
  font-size: 12px;
  opacity: 0.65;
  white-space: nowrap;
}
.tr-activity-row .tr-activity-when {
  min-width: 84px;
  text-align: right;
}
.tr-activity-row .tr-activity-open {
  font-size: 16px;
  width: 16px;
  height: 16px;
  opacity: 0.45;
}

.tr-activity-fresh .tr-activity-turns, .tr-activity-fresh .tr-activity-when {
  opacity: 1;
  font-weight: 600;
}

.tr-chip-new, .tr-tab-count {
  padding: 1px 7px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600;
  background: #61afef;
  color: #fff;
  white-space: nowrap;
}

.tr-tab-count {
  margin-left: 6px;
}

.tr-activity-ended {
  font-size: 12px;
  opacity: 0.6;
}

.tr-live {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  opacity: 0.8;
  white-space: nowrap;
}

.tr-live-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #61afef;
  animation: tr-pulse 1.4s ease-in-out infinite;
}

@keyframes tr-pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.3;
  }
}
.tr-convo {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  font-size: 13px;
}

.tr-convo-strip {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 4px 12px 4px 4px;
  border-bottom: 1px solid rgba(128, 128, 128, 0.25);
}
.tr-convo-strip .tr-convo-title {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}
.tr-convo-strip .tr-convo-title mat-icon {
  font-size: 15px;
  width: 15px;
  height: 15px;
  opacity: 0.6;
}
.tr-convo-strip .tr-convo-meta {
  flex: 1;
  min-width: 0;
  font-size: 12px;
  opacity: 0.65;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.tr-convo-strip .tr-convo-readonly {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  opacity: 0.65;
  white-space: nowrap;
}
.tr-convo-strip .tr-convo-readonly mat-icon {
  font-size: 14px;
  width: 14px;
  height: 14px;
}
.tr-convo-strip .tr-convo-edit {
  flex: none;
  height: 28px;
  font-size: 12px;
}

.tr-convo-note {
  padding: 6px 14px;
  font-size: 12px;
}

.tr-convo-fb, .tr-activity-fb {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  opacity: 0.7;
  white-space: nowrap;
}
.tr-convo-fb mat-icon, .tr-activity-fb mat-icon {
  font-size: 14px;
  width: 14px;
  height: 14px;
}

.tr-fb {
  padding: 8px 14px 4px;
  border-bottom: 1px solid rgba(128, 128, 128, 0.25);
}
.tr-fb label {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  opacity: 0.7;
}

.tr-fb-row {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
  margin-bottom: 8px;
}

.tr-convo-messages {
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.num {
  text-align: right;
  font-variant-numeric: tabular-nums;
}

:host ::ng-deep .tr-field .mat-mdc-form-field, :host ::ng-deep .tr-field-head .mat-mdc-form-field {
  font-size: 13px;
}
:host ::ng-deep .tr-never-box {
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 12.5px;
  line-height: 1.5;
}
:host ::ng-deep .tr-channel .mdc-label {
  font-size: 13px;
  font-weight: 500;
  text-transform: none;
  letter-spacing: 0;
  opacity: 1;
  white-space: nowrap;
  cursor: pointer;
}
:host ::ng-deep .tr-channel-off .mdc-label {
  opacity: 0.55;
  text-decoration: line-through;
}`, "",{"version":3,"sources":["webpack://./src/app/components/strategy-grid/trusts-widget/trusts-widget.component.scss"],"names":[],"mappings":"AAGA;EAAU,gBAAA;AADV;;AAGA;EAAW,kBAAA;EAAoB,aAAA;EAAc,gBAAA;EAAkB,gBAAA;AAI/D;;AAFA;EAAgB,eAAA;AAMhB;;AAJA;EAAY,gBAAA;AAQZ;;AAPA;EACE,aAAA;EAAe,mBAAA;EAAqB,QAAA;EAAU,eAAA;AAahD;AAZE;EAAW,YAAA;AAeb;AAdE;EAAiB,eAAA;EAAiB,gBAAA;AAkBpC;;AAhBA;EAAW,YAAA;EAAa,yBAAA;AAqBxB;;AAnBA;EAAY,iBAAA;EAAmB,mBAAA;AAwB/B;;AAvBA;EAAsB,YAAA;AA2BtB;;AA1BA;EAAe,eAAA;EAAiB,gBAAA;AA+BhC;;AA9BA;EACE,gBAAA;EAAkB,gBAAA;EAAkB,mBAAA;EAAqB,eAAA;EAAiB,gBAAA;EAC1E,oCAAA;EAAqC,cAAA;AAsCvC;;AApCA;EAAY,iBAAA;EAAmB,aAAA;AAyC/B;;AAxCA;EACE,aAAA;EAAe,mBAAA;EAAqB,QAAA;EAAU,eAAA;EAAiB,YAAA;AA+CjE;AA9CE;EAAqB,aAAA;AAiDvB;;AA9CA;EAAa,iBAAA;EAAmB,oBAAA;EAAsB,sCAAA;AAoDtD;;AAnDA;EAAY,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,gBAAA;EAAkB,eAAA;AA2D7E;AA1DE;EAAQ,eAAA;EAAiB,yBAAA;EAA2B,sBAAA;EAAuB,YAAA;AAgE7E;;AA9DA;EAAgB,sBAAA;EAAwB,oBAAA;EAAsB,QAAA;AAoE9D;;AAnEA;EAAiB,aAAA;EAAe,mBAAA;EAAqB,SAAA;AAyErD;;AAxEA;EAAW,WAAA;AA4EX;;AA3EA;EAAa,YAAA;AA+Eb;;AA9EA;EAAe,YAAA;AAkFf;;AAjFA;EAAY,eAAA;EAAiB,YAAA;AAsF7B;;AArFA;EAAU,YAAA;EAAc,cAAA;EAAgB,YAAA;EAAc,eAAA;AA4FtD;;AA3FA;EACE,iBAAA;EAAmB,gBAAA;EACnB,2CAAA;EAA4C,kBAAA;AAgG9C;;AA9FA;EACE,aAAA;EAAe,mBAAA;EAAqB,QAAA;EAAU,qBAAA;EAAuB,gBAAA;EACrE,kDAAA;EAAmD,eAAA;AAsGrD;AApGE;EAAe,gBAAA;AAuGjB;AAtGE;EAAU,qCAAA;AAyGZ;AAxGE;EAAe,UAAA;AA2GjB;AA1GE;EACE,eAAA;EAAiB,YAAA;EAAa,YAAA;EAAc,gBAAA;EAAkB,uBAAA;EAAyB,mBAAA;AAiH3F;AAhHI;EAAW,eAAA;EAAiB,WAAA;EAAa,YAAA;EAAc,oBAAA;AAsH3D;AApHE;EAAmB,eAAA;EAAiB,YAAA;EAAa,mBAAA;AAyHnD;;AAvHA;EACE,aAAA;EAAe,eAAA;EAAiB,YAAA;AA4HlC;AA3HE;EAAW,eAAA;EAAiB,WAAA;EAAa,YAAA;EAAc,oBAAA;AAiIzD;;AA9HA;EAAY,mBAAA;AAkIZ;;AAjIA;EAAiB,iBAAA;EAAmB,oBAAA;AAsIpC;;AArIA;EAAiB,iBAAA;EAAmB,YAAA;EAAa,gBAAA;AA2IjD;;AA1IA;EAAkB,gBAAA;EAAkB,gBAAA;EAAkB,aAAA;AAgJtD;AA/IE;EAAU,eAAA;AAkJZ;AAjJE;EAAW,eAAA;EAAiB,WAAA;EAAa,YAAA;EAAc,oBAAA;AAuJzD;AAtJE;EAAM,oBAAA;EAAsB,eAAA;EAAiB,gBAAA;AA2J/C;;AAzJA;EACE,gBAAA;EAAkB,mBAAA;EAAqB,eAAA;EAAiB,gBAAA;EACxD,qCAAA;EAAsC,YAAA;AAgKxC;;AA7JA;EACE,aAAA;EAAe,mBAAA;EAAqB,QAAA;EAAU,gBAAA;AAmKhD;AAlKE;EAAW,eAAA;EAAiB,WAAA;EAAa,YAAA;EAAc,oBAAA;AAwKzD;;AArKA;EAAe,aAAA;EAAe,sBAAA;AA0K9B;;AAzKA;EACE,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,WAAA;EAC/C,iBAAA;EAAmB,SAAA;EAAW,kDAAA;EAC9B,uBAAA;EAAyB,cAAA;EAAgB,aAAA;EAAe,gBAAA;EAAkB,eAAA;AAqL5E;AAnLE;EAAU,oCAAA;AAsLZ;AArLE;EAAmB,OAAA;EAAS,YAAA;EAAc,oBAAA;EAAsB,mBAAA;EAAqB,QAAA;AA4LvF;AA3LI;EAAW,eAAA;EAAiB,WAAA;EAAa,YAAA;EAAc,YAAA;AAiM3D;AA/LE;EAAwC,eAAA;EAAiB,aAAA;EAAc,mBAAA;AAoMzE;AAnME;EAAoB,eAAA;EAAiB,iBAAA;AAuMvC;AAtME;EAAoB,eAAA;EAAiB,WAAA;EAAa,YAAA;EAAc,aAAA;AA4MlE;;AAzMA;EAA8E,UAAA;EAAY,gBAAA;AA8M1F;;AA7MA;EACE,gBAAA;EAAkB,mBAAA;EAAqB,eAAA;EAAiB,gBAAA;EACxD,mBAAA;EAAqB,WAAA;EAAa,mBAAA;AAqNpC;;AAnNA;EAAgB,gBAAA;AAuNhB;;AAtNA;EAAqB,eAAA;EAAiB,YAAA;AA2NtC;;AA1NA;EAAW,oBAAA;EAAsB,mBAAA;EAAqB,QAAA;EAAU,eAAA;EAAiB,YAAA;EAAa,mBAAA;AAmO9F;;AAlOA;EACE,UAAA;EAAY,WAAA;EAAa,kBAAA;EAAoB,mBAAA;EAC7C,6CAAA;AAwOF;;AAtOA;EAAsB;IAAW,UAAA;EA2O/B;EA3O6C;IAAM,YAAA;EA8OnD;AACF;AA5OA;EAAY,OAAA;EAAS,aAAA;EAAe,aAAA;EAAe,sBAAA;EAAwB,eAAA;AAmP3E;;AAlPA;EACE,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,yBAAA;EAC/C,kDAAA;AAwPF;AAtPE;EAAkB,oBAAA;EAAsB,mBAAA;EAAqB,QAAA;EAAU,mBAAA;AA4PzE;AA3PI;EAAW,eAAA;EAAiB,WAAA;EAAa,YAAA;EAAc,YAAA;AAiQ3D;AA/PE;EAAiB,OAAA;EAAS,YAAA;EAAc,eAAA;EAAiB,aAAA;EAAc,gBAAA;EAAkB,uBAAA;EAAyB,mBAAA;AAwQpH;AAvQE;EAAqB,oBAAA;EAAsB,mBAAA;EAAqB,QAAA;EAAU,eAAA;EAAiB,aAAA;EAAc,mBAAA;AA+Q3G;AA9QI;EAAW,eAAA;EAAiB,WAAA;EAAa,YAAA;AAmR7C;AAjRE;EAAiB,UAAA;EAAY,YAAA;EAAc,eAAA;AAsR7C;;AApRA;EAAiB,iBAAA;EAAmB,eAAA;AAyRpC;;AAxRA;EACE,oBAAA;EAAsB,mBAAA;EAAqB,QAAA;EAAU,eAAA;EAAiB,YAAA;EAAa,mBAAA;AAgSrF;AA/RE;EAAW,eAAA;EAAiB,WAAA;EAAa,YAAA;AAoS3C;;AAlSA;EACE,qBAAA;EAAuB,kDAAA;AAsSzB;AArSE;EAAQ,eAAA;EAAiB,yBAAA;EAA2B,sBAAA;EAAuB,YAAA;AA2S7E;;AAzSA;EAAa,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,eAAA;EAAiB,kBAAA;AAiT7E;;AAhTA;EAAqB,OAAA;EAAS,aAAA;EAAe,gBAAA;AAsT7C;;AApTA;EAAO,iBAAA;EAAmB,kCAAA;AAyT1B;;AAtTE;EAAoE,eAAA;AA0TtE;AAzTE;EAAgB,qEAAA;EAAuE,iBAAA;EAAmB,gBAAA;AA8T5G;AA5TE;EAAyB,eAAA;EAAiB,gBAAA;EAAkB,oBAAA;EAAsB,iBAAA;EAAmB,UAAA;EAAY,mBAAA;EAAqB,eAAA;AAqUxI;AApUE;EAA6B,aAAA;EAAc,6BAAA;AAwU7C","sourcesContent":["// Trusts: the sibling of Team Policy. The base look (tabs, cards, stats,\n// tables) comes from the Team Policy stylesheet, loaded by this component too.\n\n.trusts { max-width: 920px; }\n\n.tr-lede { margin: 2px 0 14px; opacity: .78; line-height: 1.5; max-width: 760px; }\n\n.tr-pause-all { font-size: 13px; }\n\n.tr-agent { margin: 0 0 18px; }\n.tr-agent-head {\n  display: flex; align-items: center; gap: 8px; margin: 0 0 6px;\n  mat-icon { opacity: .7; }\n  .tr-agent-name { font-size: 15px; font-weight: 600; }\n}\n.tr-none { opacity: .6; padding: 4px 2px 6px 32px; }\n\n.tr-order { margin-left: 32px; padding-bottom: 4px; }\n.tr-order.tr-paused { opacity: .7; }\n.tr-sentence { font-size: 14px; line-height: 1.5; }\n.tr-chip-paused {\n  margin-left: 8px; padding: 1px 8px; border-radius: 10px; font-size: 11px; font-weight: 500;\n  background: rgba(244, 172, 57, .18); color: #f4ac39;\n}\n.tr-about { margin: 4px 0 2px; opacity: .85; }\n.tr-meta {\n  display: flex; align-items: center; gap: 4px; font-size: 12px; opacity: .9;\n  > span:first-child { opacity: .65; }\n}\n\n.tr-editor { margin-left: 32px; padding-bottom: 12px; border-color: rgba(97, 175, 239, .55); }\n.tr-field { display: flex; align-items: center; gap: 12px; margin: 12px 0 0; flex-wrap: wrap;\n  label { font-size: 11px; text-transform: uppercase; letter-spacing: .04em; opacity: .7; }\n}\n.tr-field-col { flex-direction: column; align-items: stretch; gap: 6px; }\n.tr-field-head { display: flex; align-items: center; gap: 10px; }\n.tr-wide { width: 100%; }\n.tr-person { width: 220px; }\n.tr-template { width: 170px; }\n.tr-count { font-size: 12px; opacity: .6; }\n.tr-all { min-width: 0; padding: 0 8px; height: 26px; font-size: 12px; }\n.tr-channels {\n  max-height: 232px; overflow-y: auto;\n  border: 1px solid rgba(128, 128, 128, .28); border-radius: 6px;\n}\n.tr-channel {\n  display: flex; align-items: center; gap: 8px; padding: 0 10px 0 2px; min-height: 34px;\n  border-bottom: 1px solid rgba(128, 128, 128, .16); font-size: 13px;\n\n  &:last-child { border-bottom: 0; }\n  &:hover { background: rgba(128, 128, 128, .08); }\n  mat-checkbox { flex: none; }\n  .tr-channel-note {\n    font-size: 12px; opacity: .6; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;\n    mat-icon { font-size: 13px; width: 13px; height: 13px; vertical-align: -2px; }\n  }\n  .tr-channel-when { font-size: 12px; opacity: .6; white-space: nowrap; }\n}\n.tr-kept {\n  margin: 2px 0; font-size: 12px; opacity: .7;\n  mat-icon { font-size: 13px; width: 13px; height: 13px; vertical-align: -2px; }\n}\n\n.tr-never { margin: 26px 0 18px; }\n.tr-never-card { margin-left: 32px; padding-bottom: 10px; }\n.tr-never-lede { margin: 2px 0 8px; opacity: .8; line-height: 1.5; }\n.tr-never-floor { margin: 10px 0 0; line-height: 1.5; opacity: .75;\n  summary { cursor: pointer; }\n  mat-icon { font-size: 14px; width: 14px; height: 14px; vertical-align: -2px; }\n  pre { margin: 6px 0 0 20px; font-size: 12px; line-height: 1.5; }\n}\n.tr-chip-default {\n  padding: 1px 8px; border-radius: 10px; font-size: 11px; font-weight: 500;\n  background: rgba(128, 128, 128, .18); opacity: .8;\n}\n\n.tr-editor-foot {\n  display: flex; align-items: center; gap: 8px; margin-top: 12px;\n  mat-icon { font-size: 14px; width: 14px; height: 14px; vertical-align: -2px; }\n}\n\n.tr-activity { display: flex; flex-direction: column; }\n.tr-activity-row {\n  display: flex; align-items: center; gap: 14px; width: 100%;\n  padding: 9px 10px; border: 0; border-bottom: 1px solid rgba(128, 128, 128, .22);\n  background: transparent; color: inherit; font: inherit; text-align: left; cursor: pointer;\n\n  &:hover { background: rgba(128, 128, 128, .1); }\n  .tr-activity-who { flex: 1; min-width: 0; display: inline-flex; align-items: center; gap: 6px;\n    mat-icon { font-size: 15px; width: 15px; height: 15px; opacity: .6; }\n  }\n  .tr-activity-turns, .tr-activity-when { font-size: 12px; opacity: .65; white-space: nowrap; }\n  .tr-activity-when { min-width: 84px; text-align: right; }\n  .tr-activity-open { font-size: 16px; width: 16px; height: 16px; opacity: .45; }\n}\n\n.tr-activity-fresh .tr-activity-turns, .tr-activity-fresh .tr-activity-when { opacity: 1; font-weight: 600; }\n.tr-chip-new, .tr-tab-count {\n  padding: 1px 7px; border-radius: 10px; font-size: 11px; font-weight: 600;\n  background: #61afef; color: #fff; white-space: nowrap;\n}\n.tr-tab-count { margin-left: 6px; }\n.tr-activity-ended { font-size: 12px; opacity: .6; }\n.tr-live { display: inline-flex; align-items: center; gap: 5px; font-size: 12px; opacity: .8; white-space: nowrap; }\n.tr-live-dot {\n  width: 8px; height: 8px; border-radius: 50%; background: #61afef;\n  animation: tr-pulse 1.4s ease-in-out infinite;\n}\n@keyframes tr-pulse { 0%, 100% { opacity: 1; } 50% { opacity: .3; } }\n\n// The open conversation takes the widget's whole body.\n.tr-convo { flex: 1; min-height: 0; display: flex; flex-direction: column; font-size: 13px; }\n.tr-convo-strip {\n  display: flex; align-items: center; gap: 10px; padding: 4px 12px 4px 4px;\n  border-bottom: 1px solid rgba(128, 128, 128, .25);\n\n  .tr-convo-title { display: inline-flex; align-items: center; gap: 6px; white-space: nowrap;\n    mat-icon { font-size: 15px; width: 15px; height: 15px; opacity: .6; }\n  }\n  .tr-convo-meta { flex: 1; min-width: 0; font-size: 12px; opacity: .65; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n  .tr-convo-readonly { display: inline-flex; align-items: center; gap: 4px; font-size: 12px; opacity: .65; white-space: nowrap;\n    mat-icon { font-size: 14px; width: 14px; height: 14px; }\n  }\n  .tr-convo-edit { flex: none; height: 28px; font-size: 12px; }\n}\n.tr-convo-note { padding: 6px 14px; font-size: 12px; }\n.tr-convo-fb, .tr-activity-fb {\n  display: inline-flex; align-items: center; gap: 4px; font-size: 12px; opacity: .7; white-space: nowrap;\n  mat-icon { font-size: 14px; width: 14px; height: 14px; }\n}\n.tr-fb {\n  padding: 8px 14px 4px; border-bottom: 1px solid rgba(128, 128, 128, .25);\n  label { font-size: 11px; text-transform: uppercase; letter-spacing: .04em; opacity: .7; }\n}\n.tr-fb-row { display: flex; align-items: center; gap: 14px; flex-wrap: wrap; margin-bottom: 8px; }\n.tr-convo-messages { flex: 1; min-height: 0; overflow: hidden; }\n\n.num { text-align: right; font-variant-numeric: tabular-nums; }\n\n:host ::ng-deep {\n  .tr-field .mat-mdc-form-field, .tr-field-head .mat-mdc-form-field { font-size: 13px; }\n  .tr-never-box { font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace; font-size: 12.5px; line-height: 1.5; }\n  // the checkbox's own label must not take the field's small uppercase label style\n  .tr-channel .mdc-label { font-size: 13px; font-weight: 500; text-transform: none; letter-spacing: 0; opacity: 1; white-space: nowrap; cursor: pointer; }\n  .tr-channel-off .mdc-label { opacity: .55; text-decoration: line-through; }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
